<template>
  <div class="w-full h-full">
    <l-map
      :use-global-leaflet="false"
      v-model="zoom"
      v-model:zoom="zoom"
      :center="[lat, lng]"
    >
      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      ></l-tile-layer>

      <l-marker :lat-lng="[lat, lng]" draggable>
        <l-icon :icon-anchor="[16, 40]" :icon-size="[32, 40]" :popup-anchor="[0, -40]" :class-name="''">
          <MapPinIconWhiteFill class="w-8 h-10 fill-primary" />
        </l-icon>
      </l-marker>
    </l-map>
  </div>
</template>
<script setup lang="ts">
  import 'leaflet/dist/leaflet.css';

  import { LIcon,LMap, LMarker, LTileLayer } from '@vue-leaflet/vue-leaflet';
  import { ref } from 'vue';

  import MapPinIconWhiteFill from '../icons/MapPinIconWhiteFill.vue';

  const zoom = ref(10);

  defineProps<{
    lat: number;
    lng: number;
  }>();
</script>
